import React, { useCallback, useState } from 'react';
import OnboardingModal from '../GetStarted/GetStartedWidget/OnboardingModal/OnboardingModal';
import { selectSessionProperties, selectSignedUserProfile, setSessionProperty, UserOnboarding } from '@src/app/reducers/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import useAnalyticsTracker from '@hooks/useAnalyticsTracker';

const OnboardingManager = () => {
  const dispatch = useDispatch();
  const sessionProperties = useSelector(selectSessionProperties);
  const { trackEvent } = useAnalyticsTracker('onboarding');
  const userInfo = useSelector(selectSignedUserProfile)
  const firstTimeUser = Boolean(userInfo && !sessionProperties.watchedVideos.welcomeMessage);
  const [welcomeNotWatched, setWelcomeNotWatched] = useState(firstTimeUser);
  

  const dispatchUpdateOnboarding = useCallback((property: keyof UserOnboarding, value: boolean): void => {
		dispatch(setSessionProperty({
      watchedVideos: {
        ...(sessionProperties.watchedVideos as UserOnboarding),
        [property]: value
      }
    }));
	}, [dispatch, sessionProperties]);

  const handleVideoWatched = useCallback((video: keyof UserOnboarding) => {
    trackEvent(`${video}_watched`);
		dispatchUpdateOnboarding( video, true);
	}, [dispatchUpdateOnboarding, trackEvent]);

  const handleModalClosed = useCallback((openLauncher?: boolean) => {
    // allow the modal to be shown again on the next reload
    setWelcomeNotWatched(false);
    trackEvent('modal_closed');
		dispatch(setSessionProperty({
			onboardingModalVisible: false
		}));
	}, [dispatch, trackEvent]);


  // Wait for user account to be fetched
	if (!userInfo.profile) { return null; }
  
  return (
    <>  
      {(sessionProperties.onboardingModalVisible || welcomeNotWatched) && (
        <OnboardingModal
          onboardingItems={sessionProperties.watchedVideos}
          onCloseModal={handleModalClosed}
          dispatchVideoWatched={handleVideoWatched}
          firstTimeUser={firstTimeUser}
          userProfile={userInfo.profile}
        />
      )}
    </>
  )
}

export default OnboardingManager